
define(
	'Code25.CaterpartsGlobal.Addressio'
	, [
		'Code25.CaterpartsGlobal.Addressio.View'
	]
	, function (
		Code25CaterpartsGlobalAddressioView
	) {
		'use strict';

		return {
			mount: function mount(container) {

				var layout = container.getComponent('Layout');
				layout.registerView('Addressio', function () {
					return new Code25CaterpartsGlobalAddressioView({ application: container });
				});

			}
		};

	});



